/**
 * Persistence for the tour — a tiny wrapper over localStorage keyed by
 * tour name. This is ephemeral UI state, so localStorage (not Redux) is
 * the right home per the frontend standards. Exported so it is directly
 * unit-testable without rendering a component.
 */

const PREFIX = 'tour:seen';

/**
 * Read whether a tour has been completed. Defaults to false.
 */
export function getTourSeen(name: string): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(`${PREFIX}:${name}`) === 'true';
  } catch {
    return false;
  }
}

/** Mark a tour as completed (seen). */
export function setTourSeen(name: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(`${PREFIX}:${name}`, 'true');
  } catch {
    // Ignore storage failures (private mode, quota) — the tour simply
    // re-runs next visit rather than breaking the page.
  }
}
